import React from "react";
import { Spin } from "antd";
import "../Theme.less"

const AppLoading = () => {
  return <Spin size="large" className="app_loading_spin" />;
};

export default AppLoading;
